import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CidaasService } from 'src/app/service/cidaas.service';
import { CommonFunctionsService } from 'src/app/service/common-functions.service';
import { environment } from 'src/environments/environment';
import {ILocation, LocationHelper} from '../../../helpers/location.helper';

@Component({
  selector: 'app-login-success',
  templateUrl: './login-success.component.html',
  styleUrls: ['./login-success.component.scss'],
})
export class LoginSuccessComponent implements OnInit {
  requestId!: string;
  user!: string;
  operation = 'OPERATION.SIGNED_IN';
  track_id: string = '';
  location: ILocation = {
    lat: '',
    lon: ''
  };
  constructor(private route: ActivatedRoute, public commonFunc: CommonFunctionsService, public cidaasService: CidaasService) { }

  ngOnInit(): void {
    this.getLatLon();
    this.route.queryParams.subscribe((params) => {
      this.user = params.name || null;
      this.requestId = params.requestId || null;
      this.track_id = params.track_id;
    });
  }

  getLatLon(): void {
    const lat = localStorage.getItem('lat');
    const lon = localStorage.getItem('lon');
    if (lat && lon) {
      this.location.lat = lat;
      this.location.lon = lon;
    } else {
      LocationHelper.getLocationInfo().then((info: ILocation) => {
        this.location = info;
      }).catch((error) => {
        this.location.lat = '';
        this.location.lon = '';
      });
    }
  }

  goToPortal(): void {
    const options = { track_id: this.track_id, lat: this.location.lat, lon: this.location.lon };
    this.cidaasService.mfaContinue(options);
  }
}
